module.exports = __webpack_public_path__ + "static/img/gomedicalWhite2.6ab8501.png";


//////////////////
// WEBPACK FOOTER
// /src/assets/img/gomedicalWhite2.png
// module id = 7q3A
// module chunks = 1